// // import React, { useState } from 'react';
// // import Layout from './Components/Layout';
// // import Login from './Components/Login';
// // import Dashboard from './Components/Dashboard';
// // import RoomAllocation from './Components/RoomAllocation';
// // import RoomChecklist from './Components/RoomChecklist';
// // import DamageReport from './Components/DamageReport';
// // import IssueReview from './Components/IssueReview';
// // import AuditReport from './Components/AuditReport';
// // import TaskManagement from './Components/TaskManagement';
// // import StaffManagement from './Components/StaffManagement';
// // function App() {
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);
// //   const [currentStaff, setCurrentStaff] = useState(null)
// //   const [currentView, setCurrentView] = useState('dashboard');
// //   const [allocationData, setAllocationData] = useState(null);
// //   const [checklistData, setChecklistData] = useState({});
// //   const [damageReports, setDamageReports] = useState([]);

// //   const handleLogin = (staffData) => {
// //     setIsLoggedIn(true);
// //     setCurrentStaff(staffData);
// //     setCurrentView('dashboard');
// //   };

// //   const handleLogout = () => {
// //     setIsLoggedIn(false);
// //     setCurrentStaff(null);
// //     setCurrentView('dashboard');
// //     setAllocationData(null);
// //     setChecklistData({});
// //     setDamageReports([]);
// //   };

// //   const renderContent = () => {
// //     if (!isLoggedIn) {
// //       return <Login onLogin={handleLogin} />;
// //     }

// //     switch (currentView) {
// //       case 'dashboard':
// //         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'allocate':
// //         return <RoomAllocation onAllocate={(data) => {
// //           setAllocationData(data);
// //           setCurrentView('checklist');
// //         }} />;
// //       case 'checklist':
// //         return <RoomChecklist roomData={allocationData} onComplete={(data) => {
// //           setChecklistData(data);
// //           setCurrentView('damage');
// //         }} />;
// //       case 'damage':
// //         return <DamageReport roomData={allocationData} onReport={(reports) => {
// //           setDamageReports(reports);
// //           setCurrentView('review');
// //         }} />;
// //         // In App.js, add to the renderContent switch statement:
// // case 'staff':
// //   return <StaffManagement staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'review':
// //         return <IssueReview 
// //           checklistData={checklistData} 
// //           damageReports={damageReports}
// //           roomData={allocationData}
// //           onComplete={() => setCurrentView('audit')}
// //           onRework={() => setCurrentView('checklist')}
// //         />;
// //         case 'tasks':
// //   return <TaskManagement staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'audit':
// //         return <AuditReport 
// //           roomData={allocationData}
// //           checklistData={checklistData}
// //           damageReports={damageReports}
// //           onFinish={() => {
// //             setAllocationData(null);
// //             setCurrentView('dashboard');
// //           }}
// //         />;
// //       default:
// //         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
// //     }
// //   };

// //   return (
// //     <Layout isLoggedIn={isLoggedIn} currentStaff={currentStaff} onLogout={handleLogout} onNavigate={setCurrentView}>
// //       {renderContent()}
// //     </Layout>
// //   );
// // }

// // export default App;

// // import React, { useState } from 'react';
// // import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
// // import { useEffect } from 'react';
// // import Layout from './Components/Layout';
// // import Login from './Components/Login';
// // import Dashboard from './Components/Dashboard';
// // import RoomAllocation from './Components/RoomAllocation';
// // import RoomChecklist from './Components/RoomChecklist';
// // import DamageReport from './Components/DamageReport';
// // import IssueReview from './Components/IssueReview';
// // import AuditReport from './Components/AuditReport';
// // import TaskManagement from './Components/TaskManagement';
// // import StaffManagement from './Components/StaffManagement';
// // import Home from './Pages/Home';

// // // Scroll to top component
// // function ScrollToTop() {
// //   const { pathname } = useLocation();

// //   useEffect(() => {
// //     window.scrollTo({
// //       top: 0,
// //       behavior: "smooth"
// //     });
// //   }, [pathname]);

// //   return null;
// // }

// // // Protected Route wrapper component
// // function ProtectedRoute({ children, isLoggedIn }) {
// //   if (!isLoggedIn) {
// //     return <Navigate to="/" replace />;
// //   }
// //   return children;
// // }

// // // Main App Content with state management
// // function AppContent() {
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);
// //   const [currentStaff, setCurrentStaff] = useState(null);
// //   const [currentView, setCurrentView] = useState('dashboard');
// //   const [allocationData, setAllocationData] = useState(null);
// //   const [checklistData, setChecklistData] = useState({});
// //   const [damageReports, setDamageReports] = useState([]);
// //   const navigate = useNavigate();

// //   const handleLogin = (staffData) => {
// //     setIsLoggedIn(true);
// //     setCurrentStaff(staffData);
// //     setCurrentView('dashboard');
// //     navigate('/dashboard');
// //   };

// //   const handleLogout = () => {
// //     setIsLoggedIn(false);
// //     setCurrentStaff(null);
// //     setCurrentView('dashboard');
// //     setAllocationData(null);
// //     setChecklistData({});
// //     setDamageReports([]);
// //     navigate('/');
// //   };

// //   const renderContent = () => {
// //     switch (currentView) {
// //       case 'dashboard':
// //         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'allocate':
// //         return <RoomAllocation onAllocate={(data) => {
// //           setAllocationData(data);
// //           setCurrentView('checklist');
// //         }} />;
// //       case 'checklist':
// //         return <RoomChecklist roomData={allocationData} onComplete={(data) => {
// //           setChecklistData(data);
// //           setCurrentView('damage');
// //         }} />;
// //       case 'damage':
// //         return <DamageReport roomData={allocationData} onReport={(reports) => {
// //           setDamageReports(reports);
// //           setCurrentView('review');
// //         }} />;
// //       case 'staff':
// //         return <StaffManagement staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'review':
// //         return <IssueReview 
// //           checklistData={checklistData} 
// //           damageReports={damageReports}
// //           roomData={allocationData}
// //           onComplete={() => setCurrentView('audit')}
// //           onRework={() => setCurrentView('checklist')}
// //         />;
// //       case 'tasks':
// //         return <TaskManagement staff={currentStaff} onNavigate={setCurrentView} />;
// //       case 'audit':
// //         return <AuditReport 
// //           roomData={allocationData}
// //           checklistData={checklistData}
// //           damageReports={damageReports}
// //           onFinish={() => {
// //             setAllocationData(null);
// //             setCurrentView('dashboard');
// //           }}
// //         />;
// //       default:
// //         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
// //     }
// //   };

// //   return (
// //     <Routes>
// //       {/* Public Route - Home Page */}
// //       <Route 
// //         path="/" 
// //         element={<Home />} 
// //       />
      
// //       {/* Protected Dashboard Routes */}
// //       <Route 
// //         path="/dashboard/*" 
// //         element={
// //           <ProtectedRoute isLoggedIn={isLoggedIn}>
// //             <Layout 
// //               isLoggedIn={isLoggedIn} 
// //               currentStaff={currentStaff} 
// //               onLogout={handleLogout} 
// //               onNavigate={setCurrentView}
// //             >
// //               {renderContent()}
// //             </Layout>
// //           </ProtectedRoute>
// //         } 
// //       />
      
// //       {/* Login Route - Redirect to dashboard if already logged in */}
// //       <Route 
// //         path="/login" 
// //         element={
// //           isLoggedIn ? 
// //             <Navigate to="/dashboard" replace /> : 
// //             <Login onLogin={handleLogin} />
// //         } 
// //       />
// //     </Routes>
// //   );
// // }

// // // Main App component with Router
// // function App() {
// //   return (
// //     <Router>
// //       <ScrollToTop />
// //       <AppContent />
// //     </Router>
// //   );
// // }

// // export default App;


// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
// import { useEffect } from 'react';
// import Layout from './Components/Layout';
// import Login from './Components/Login';
// import Dashboard from './Components/Dashboard';
// import RoomAllocation from './Components/RoomAllocation';
// import RoomChecklist from './Components/RoomChecklist';
// import DamageReport from './Components/DamageReport';
// import IssueReview from './Components/IssueReview';
// import AuditReport from './Components/AuditReport';
// import TaskManagement from './Components/TaskManagement';
// import StaffManagement from './Components/StaffManagement';
// import Home from './Pages/Home';

// // Scroll to top component
// function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth"
//     });
//   }, [pathname]);

//   return null;
// }

// // Protected Route wrapper component
// function ProtectedRoute({ children }) {
//   const token = localStorage.getItem('token');
//   const user = localStorage.getItem('user');
//   const location = useLocation();
  
//   if (!token || !user) {
//     // Redirect to home page if not authenticated
//     return <Navigate to="/" state={{ from: location }} replace />;
//   }
  
//   return children;
// }

// // Main App Content with state management
// function AppContent() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [currentStaff, setCurrentStaff] = useState(null);
//   const [currentView, setCurrentView] = useState('dashboard');
//   const [allocationData, setAllocationData] = useState(null);
//   const [checklistData, setChecklistData] = useState({});
//   const [damageReports, setDamageReports] = useState([]);
//   const navigate = useNavigate();

//   // Check if user is already logged in on app load
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     const userData = localStorage.getItem('user');
    
//     if (token && userData) {
//       const parsedUser = JSON.parse(userData);
//       setIsLoggedIn(true);
//       setCurrentStaff(parsedUser);
//       // Don't auto-navigate here, let routes handle it
//     }
//   }, []);

//   const handleLogin = (staffData) => {
//     setIsLoggedIn(true);
//     setCurrentStaff(staffData);
//     setCurrentView('dashboard');
//     // Navigate to dashboard after successful login
//     navigate('/dashboard');
//   };

//   const handleLogout = () => {
//     // Clear all localStorage data
//     localStorage.clear();
//     setIsLoggedIn(false);
//     setCurrentStaff(null);
//     setCurrentView('dashboard');
//     setAllocationData(null);
//     setChecklistData({});
//     setDamageReports([]);
//     // Navigate to home page
//     navigate('/');
//   };

//   const renderContent = () => {
//     switch (currentView) {
//       case 'dashboard':
//         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
//       case 'allocate':
//         return <RoomAllocation onAllocate={(data) => {
//           setAllocationData(data);
//           setCurrentView('checklist');
//         }} />;
//       case 'checklist':
//         return <RoomChecklist roomData={allocationData} onComplete={(data) => {
//           setChecklistData(data);
//           setCurrentView('damage');
//         }} />;
//       case 'damage':
//         return <DamageReport roomData={allocationData} onReport={(reports) => {
//           setDamageReports(reports);
//           setCurrentView('review');
//         }} />;
//       case 'staff':
//         return <StaffManagement staff={currentStaff} onNavigate={setCurrentView} />;
//       case 'review':
//         return <IssueReview 
//           checklistData={checklistData} 
//           damageReports={damageReports}
//           roomData={allocationData}
//           onComplete={() => setCurrentView('audit')}
//           onRework={() => setCurrentView('checklist')}
//         />;
//       case 'tasks':
//         return <TaskManagement staff={currentStaff} onNavigate={setCurrentView} />;
//       case 'audit':
//         return <AuditReport 
//           roomData={allocationData}
//           checklistData={checklistData}
//           damageReports={damageReports}
//           onFinish={() => {
//             setAllocationData(null);
//             setCurrentView('dashboard');
//           }}
//         />;
//       default:
//         return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
//     }
//   };

//   return (
//     <Routes>
//       {/* Public Route - Home Page */}
//       <Route 
//         path="/" 
//         element={<Home />} 
//       />
      
//       {/* Login Route - Redirect to dashboard if already logged in */}
//       <Route 
//         path="/login" 
//         element={
//           isLoggedIn ? 
//             <Navigate to="/dashboard" replace /> : 
//             <Login onLogin={handleLogin} />
//         } 
//       />
      
//       {/* Protected Dashboard Routes */}
//       <Route 
//         path="/dashboard" 
//         element={
//           <ProtectedRoute>
//             <Layout 
//               isLoggedIn={isLoggedIn} 
//               currentStaff={currentStaff} 
//               onLogout={handleLogout} 
//               onNavigate={setCurrentView}
//             >
//               {renderContent()}
//             </Layout>
//           </ProtectedRoute>
//         } 
//       />
      
//       <Route 
//         path="/dashboard/*" 
//         element={
//           <ProtectedRoute>
//             <Layout 
//               isLoggedIn={isLoggedIn} 
//               currentStaff={currentStaff} 
//               onLogout={handleLogout} 
//               onNavigate={setCurrentView}
//             >
//               {renderContent()}
//             </Layout>
//           </ProtectedRoute>
//         } 
//       />
//       // In your App.js or wherever you render Layout
// <Layout 
//   isLoggedIn={isLoggedIn} 
//   currentStaff={currentStaff} 
//   onLogout={handleLogout} 
//   onNavigate={setCurrentView}
// >
//   {renderContent()}
// </Layout>
//       {/* Catch all - redirect to home */}
//       <Route path="*" element={<Navigate to="/" replace />} />
//     </Routes>
//   );
// }

// // Main App component with Router
// function App() {
//   return (
//     <Router>
//       <ScrollToTop />
//       <AppContent />
//     </Router>
//   );
// }

// export default App;


import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './Components/Layout';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import RoomAllocation from './Components/RoomAllocation';
import RoomChecklist from './Components/RoomChecklist';
import DamageReport from './Components/DamageReport';
import IssueReview from './Components/IssueReview';
import AuditReport from './Components/AuditReport';
import TaskManagement from './Components/TaskManagement';
import StaffManagement from './Components/StaffManagement';
import Home from './Pages/Home';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  return null;
}

// Protected Route wrapper component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const location = useLocation();
  
  if (!token || !user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  return children;
}

// Main App Content with state management
function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentStaff, setCurrentStaff] = useState(null);
  const [currentView, setCurrentView] = useState('dashboard');
  const [allocationData, setAllocationData] = useState(null);
  const [checklistData, setChecklistData] = useState({});
  const [damageReports, setDamageReports] = useState([]);
  const navigate = useNavigate();

  // Check if user is already logged in on app load
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setIsLoggedIn(true);
        setCurrentStaff(parsedUser);
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.clear();
      }
    }
  }, []);

  const handleLogin = (staffData) => {
    setIsLoggedIn(true);
    setCurrentStaff(staffData);
    setCurrentView('dashboard');
    navigate('/dashboard');
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setCurrentStaff(null);
    setCurrentView('dashboard');
    setAllocationData(null);
    setChecklistData({});
    setDamageReports([]);
    navigate('/');
  };

  const renderContent = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
      case 'allocate':
        return <RoomAllocation onAllocate={(data) => {
          setAllocationData(data);
          setCurrentView('checklist');
        }} />;
      case 'checklist':
        return <RoomChecklist roomData={allocationData} onComplete={(data) => {
          setChecklistData(data);
          setCurrentView('damage');
        }} />;
      case 'damage':
        return <DamageReport roomData={allocationData} onReport={(reports) => {
          setDamageReports(reports);
          setCurrentView('review');
        }} />;
      case 'staff':
        return <StaffManagement staff={currentStaff} onNavigate={setCurrentView} />;
      case 'review':
        return <IssueReview 
          checklistData={checklistData} 
          damageReports={damageReports}
          roomData={allocationData}
          onComplete={() => setCurrentView('audit')}
          onRework={() => setCurrentView('checklist')}
        />;
      case 'tasks':
        return <TaskManagement staff={currentStaff} onNavigate={setCurrentView} />;
      case 'audit':
        return <AuditReport 
          roomData={allocationData}
          checklistData={checklistData}
          damageReports={damageReports}
          onFinish={() => {
            setAllocationData(null);
            setCurrentView('dashboard');
          }}
        />;
      default:
        return <Dashboard staff={currentStaff} onNavigate={setCurrentView} />;
    }
  };

  return (
    <Routes>
      {/* Public Route - Home Page */}
      <Route path="/" element={<Home />} />
      
      {/* Login Route */}
      <Route 
        path="/login" 
        element={
          isLoggedIn ? 
            <Navigate to="/dashboard" replace /> : 
            <Login onLogin={handleLogin} />
        } 
      />
      
      {/* Protected Dashboard Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Layout 
              isLoggedIn={isLoggedIn} 
              currentStaff={currentStaff} 
              onLogout={handleLogout} 
              onNavigate={setCurrentView}
            >
              {renderContent()}
            </Layout>
          </ProtectedRoute>
        } 
      />
      
      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// Main App component with Router
function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;